import formatTenantLink from '@lib/utils/formatTenantLink';

export const customerLinkToMonolith = (tenantId: string, customerId: string) =>
  formatTenantLink(tenantId, `#/customer/${customerId}`);
export const customerLinkToMonolithSearch = (tenantId: string) =>
  formatTenantLink(tenantId, '#/Search');
export const locationLinkToMonolith = (tenantId: string, locationId: string) =>
  formatTenantLink(tenantId, `#/location/${locationId}`);
export const jobBookingLinkToMonolith = (tenantId: string, jobId: string) =>
  formatTenantLink(tenantId, `#/Job/Index/${jobId}`);
export const bookJobLinkToMonolith = (tenantId: string) =>
  formatTenantLink(tenantId, '#/Calls');
export const dashboardLinkToMonolith = (tenantId: string) =>
  formatTenantLink(tenantId, '#/Dashboard');
export const callContinuityLinkToMonolith = (tenantId: string) =>
  formatTenantLink(tenantId, '#/Settings/CallContinuity');
export const phoneNumbersLinkToMonolith = (tenantId: string) =>
  formatTenantLink(tenantId, '#/Settings/phoneNumbers');

// format from number from +17172012010 to (717)+201-2010
export function formatCallerNumberForCallBubbleDetect(from: string): string {
  const match = RegExp(/\+1(\d{3})(\d{3})(\d{4})/).exec(from);
  if (!match) {
    return from;
  }
  return `(${match[1]})+${match[2]}-${match[3]}`;
}
